import { h, Component } from 'preact';
import { BaseField } from '../BaseField';

import { bind, memoize, debounce } from 'decko';
import Select from 'preact-material-components/Select';
import FormField from 'preact-material-components/FormField';

import { IDropDownProps, IDropDownState } from './IDropDown';

//let style = require('./style.css');

export class DropDown extends BaseField<IDropDownProps, IDropDownState> {

    constructor(props: IDropDownProps, ctx) {
        super(props, ctx);
        this.setState({
            value: props.value,
            selectedIndex: this.props.options.map(o => o.value).indexOf(props.value)
        });
    }

    @bind
    public onChange(e) {
        if (e.selectedIndex > -1) {
            console.log(e);
            var value = e.selectedIndex == -1 ? undefined : this.props.options[e.selectedIndex].value;
            this.setState({
                value: value,
                selectedIndex: e.selectedIndex
            });
        }
        if (this.props.onChange)
            this.props.onChange(value);
    }

    render() {
        console.log("state:",this.state);
        var options = this.props.options.map((option, i) => {
            return <Select.Item value={option.value}>{option.text}</Select.Item>
        });
        return (
            <FormField class={this.props.class}>
                <Select style={{minWidth:'200px'}} hintText={this.props.label}
                    selectedIndex={this.state.selectedIndex}
                    
                    onChange={this.onChange}>
                    {options}
                </Select>
            </FormField>
        );
    }
}




// WEBPACK FOOTER //
// ./components/forms/fields/dropDown/DropDown.tsx